import React from 'react';
import { Grid, Card } from 'semantic-ui-react';
var Header = function () {
    return React.createElement(Card, { fluid: true, style: { background: '#eef1f8', border: 'none' }, className: "mb0 no-border-radius" },
        React.createElement(Card.Content, null,
            React.createElement(Grid, { className: "py2 font-weight-bold" },
                React.createElement(Grid.Column, { width: 5 },
                    React.createElement("span", { style: { width: 48, display: 'inline-block' } }),
                    React.createElement("span", { className: "pl3" }, "Name")),
                React.createElement(Grid.Column, { width: 5 }, "Status"),
                React.createElement(Grid.Column, { width: 5 }))));
};
export default Header;
